// extracted by mini-css-extract-plugin
module.exports = {"container":"ReducedChatWindow_container___YIGb"};